import React from 'react'

// Components
import Team from 'components/flex/Team/Team'

interface TeamShellProps {
  // eslint-disable-next-line
  fields: GatsbyTypes.WpPage_Flexcontent_Flex_PostTypes
  location?: any
}

interface PostProps {
  [key: string]: any
}

const TeamShell: React.FC<TeamShellProps> = ({ fields, location = {} }) => {
  const types: PostProps = {
    standard: Team,
  }

  if (!fields.styletype || !types[fields.styletype]) {
    return null
  }

  const Component = types[fields.styletype]

  return (
    <Component
      key={`${location ? location.pathname : 'flex'}`}
      fields={fields}
      location={location}
    />
  )
}

export default TeamShell
